import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "debug-tracker"
}
const _hoisted_3 = { class: "selectable" }
const _hoisted_4 = { class: "selector" }
const _hoisted_5 = { class: "selector" }
const _hoisted_6 = { class: "selector" }
const _hoisted_7 = { class: "selector" }
const _hoisted_8 = { class: "start" }
const _hoisted_9 = { class: "x" }
const _hoisted_10 = { class: "y" }
const _hoisted_11 = { class: "x" }
const _hoisted_12 = { class: "y" }
const _hoisted_13 = { class: "start" }
const _hoisted_14 = { class: "x" }
const _hoisted_15 = { class: "y" }
const _hoisted_16 = { class: "start" }
const _hoisted_17 = { class: "y" }
const _hoisted_18 = { class: "x" }
const _hoisted_19 = { class: "x" }
const _hoisted_20 = { class: "y" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "selectable-area",
    onMousedown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onMouseDown && _ctx.onMouseDown(...args)), ["stop"])),
    ref: "el",
    id: _ctx.selectorId
  }, [
    (_ctx.debug)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.selection?.length) + " / " + _toDisplayString(_ctx.target?.length) + " selected", 1),
          _createElementVNode("div", _hoisted_4, "mouseDown: " + _toDisplayString(_ctx.mouseDown), 1),
          _createElementVNode("div", _hoisted_5, "Selector: " + _toDisplayString(_ctx.selector), 1),
          _createElementVNode("div", _hoisted_6, "Path: " + _toDisplayString(_ctx.path), 1),
          _createElementVNode("div", _hoisted_7, "ticks: " + _toDisplayString(_ctx.ticks) + "ms", 1),
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createTextVNode("startPoint")),
            _createElementVNode("div", _hoisted_9, "X " + _toDisplayString(_ctx.startPoint?.x), 1),
            _createElementVNode("div", _hoisted_10, "Y " + _toDisplayString(_ctx.startPoint?.y), 1),
            _createElementVNode("div", _hoisted_11, "offsetX " + _toDisplayString(_ctx.startPoint?.offsetX), 1),
            _createElementVNode("div", _hoisted_12, "offsetY " + _toDisplayString(_ctx.startPoint?.offsetY), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[2] || (_cache[2] = _createTextVNode("endPoint")),
            _createElementVNode("div", _hoisted_14, "X " + _toDisplayString(_ctx.endPoint?.x), 1),
            _createElementVNode("div", _hoisted_15, "Y " + _toDisplayString(_ctx.endPoint?.y), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[3] || (_cache[3] = _createTextVNode("selectionBox")),
            _createElementVNode("div", _hoisted_17, "X " + _toDisplayString(_ctx.selectionBox[0]), 1),
            _createElementVNode("div", _hoisted_18, "Y " + _toDisplayString(_ctx.selectionBox[1]), 1),
            _createElementVNode("div", _hoisted_19, "Width " + _toDisplayString(_ctx.selectionBox[2]), 1),
            _createElementVNode("div", _hoisted_20, "Height " + _toDisplayString(_ctx.selectionBox[3]), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", { selection: _ctx.selection }, undefined, true),
    (_ctx.mouseDown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "selectable-area-box",
          style: _normalizeStyle(_ctx.selectionBoxStyling)
        }, null, 4))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}